import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

const lang = localStorage.getItem("lang") || "en";

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    lng: lang,
    debug: true,
    ns: ["translations"],
    defaultNS: "translations",
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        translations: require("./assets/locales/en/translation.json"),
      },
      ar: {
        translations: require("./assets/locales/ar/translation.json"),
      },
    },
  });

export default i18n;
